const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function handle(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(typeof data.detail === 'string' ? data.detail : 'Something went wrong');
    err.status = res.status;
    throw err;
  }
  return data;
}

export const studentApi = (path, { method = 'GET', body } = {}) =>
  fetch(`${API}/journey${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  }).then(handle);

export const adminToken = () => sessionStorage.getItem('admin_token');

export const adminApi = (path, { method = 'GET', body } = {}) =>
  fetch(`${API}/journey/admin${path}`, {
    method,
    credentials: 'include',
    headers: { Authorization: `Bearer ${adminToken()}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  }).then(handle);

export const adminLogin = (pin) =>
  fetch(`${API}/admin/login`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pin }),
  }).then(handle);

export const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

export const PROGRAM_NAMES = {
  direction: 'Career Direction Blueprint',
  skills: 'Role Skills Execution',
  readiness: 'Career Readiness Program',
  integrated: 'Integrated Career Journey',
};

export const DIMENSIONS = [
  ['career_direction', 'Career Direction'],
  ['profile_strength', 'Profile Strength'],
  ['interview_readiness', 'Interview Readiness'],
  ['job_search', 'Job Search'],
];

export const STATE_META = {
  locked: { label: 'Locked', cls: 'bg-slate-100 text-slate-500' },
  available: { label: 'Ready to start', cls: 'bg-teal-50 text-teal-700' },
  revise: { label: 'Revise & resubmit', cls: 'bg-amber-50 text-amber-700' },
  completed: { label: 'Approved', cls: 'bg-emerald-50 text-emerald-700' },
  placed_out: { label: 'Skipped · confirmed by consultant', cls: 'bg-sky-50 text-sky-700' },
  awaiting_review: { label: 'Under consultant review', cls: 'bg-teal-50 text-teal-700' },
  validated: { label: 'Validated by specialist', cls: 'bg-emerald-100 text-emerald-800' },
};

export const EVIDENCE_META = {
  none: { label: 'No evidence yet', cls: 'bg-slate-100 text-slate-500' },
  self_reported: { label: 'Self-reported', cls: 'bg-amber-50 text-amber-700' },
  demonstrated: { label: 'Shown in reviewed work', cls: 'bg-teal-50 text-teal-700' },
  validated: { label: 'Validated by specialist', cls: 'bg-emerald-100 text-emerald-800' },
};
